import LoadingButton from "../../../../components/LoadingButton"

const MODES = [
    {
        key: 'auto',
        icon: 'bolt',
        title: 'Automatic',
        description: 'Run the matching algorithm. Review proposed pairs and approve or reject each one.'
    },
    {
        key: 'manual',
        icon: 'edit',
        title: 'Manual',
        description: 'No algorithm. Build every pairing yourself from the participants table.'
    },
]

export default function ModePickerCard({
    menteeCount,
    mentorCount,
    mode,
    onModeChange,
    onRunAlgorithm,
    autoEnabled,
    running,
}) {

    const heading = (() => {
        if (menteeCount == null || mentorCount == null) return 'Matching'
        if (menteeCount === 0 && mentorCount === 0) return 'No participants waiting to be matched'
        const menteeLabel = `${menteeCount} ${menteeCount === 1 ? 'mentee' : 'mentees'}`
        const mentorLabel = `${mentorCount} ${mentorCount === 1 ? 'mentor' : 'mentors'}`
        return `${menteeLabel} · ${mentorLabel} waiting to be matched`
    })()

    const noneWaiting = menteeCount === 0 && mentorCount === 0
    const subheading = noneWaiting
        ? 'Run again once new participants enrol.'
        : 'Pick how to handle this batch.'

    const isAuto = mode === 'auto'
    const runDisabled = !autoEnabled || menteeCount === 0 || mentorCount === 0

    return (
        <div className="card standard-padding-s">
            <p className="batch-heading">{heading}</p>
            <p className="batch-subheading v-spacer-s">{subheading}</p>

            <div className={`two-columns gap-s ${isAuto ? 'v-spacer-s' : ''}`}>
                {MODES.map(m => {
                    const disabled = m.key === 'auto' && !autoEnabled
                    const selected = mode === m.key
                    return (
                        <button
                            key={m.key}
                            type="button"
                            className={`mode-card ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
                            onClick={() => { if (!disabled) onModeChange(m.key) }}
                            aria-pressed={selected}
                            disabled={disabled}
                        >
                            <div className="mode-card-header">
                                <span className="material-symbols-outlined mode-card-icon">{m.icon}</span>
                                <span className="mode-card-title">{m.title}</span>
                            </div>
                            <p className="mode-card-desc">{m.description}</p>
                            {disabled && (
                                <p className="mode-hint">Add a questionnaire to enable automatic matching.</p>
                            )}
                        </button>
                    )
                })}
            </div>

            {isAuto && (
                <div className="flex gap-xs">
                    <LoadingButton
                        className={`solid ${runDisabled ? 'disabled' : ''}`}
                        label="Run algorithm"
                        loading={running}
                        disabled={runDisabled}
                        onClick={onRunAlgorithm}
                    />
                </div>
            )}
        </div>
    )
}
